import React from 'react';
import {connect} from 'react-redux';
import {changeDeviceSettings} from '../../../common/device/actions';

class KitchenPrintItemStyle extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        kitchenItemsSeparate: React.PropTypes.bool,
        changeDeviceSettings: React.PropTypes.func
    };

    render() {
        const {kitchenItemsPrintSeparate, changeDeviceSettings, msg} = this.props;

        return (
            <div className="table-row">
                <div className="table-cell" style={{width: '55.55%'}}>
                    <div className="boxBtn text-black text-left">
                        <div className="boxBtn-inner">
                            <div className="settings-name">
                                <span className="settings-name-name">{msg.settings.kitchenItemStyle.title}</span>
                                <span className="settings-name-info">{msg.settings.kitchenItemStyle.subtitle}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="table-cell" style={{width: '44.44%'}}>
                    <div className="switch">
                        <div className={`switch-option text-l ${kitchenItemsPrintSeparate ? 'active' : ''} color-greenLight`}
                             onClick={() => changeDeviceSettings('kitchenItemsPrintSeparate', true)}>
                            <div className="switch-inner">
                                <span>{msg.settings.on}</span>
                            </div>
                        </div>
                        <div className={`switch-option text-l ${kitchenItemsPrintSeparate ? '' : 'active'} color-red`}
                             onClick={() => changeDeviceSettings('kitchenItemsPrintSeparate' ,false)}>
                            <div className="switch-inner">
                                <span>{msg.settings.off}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    kitchenItemsPrintSeparate: state.device.kitchenItemsPrintSeparate
}), {changeDeviceSettings})(KitchenPrintItemStyle);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/KitchenPrintItemStyle.js